import "./styles.less";

import React, { useState } from "react";

import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import dayjs from "dayjs";
import { useContext } from "react";
import { useEffect } from "react";
import { useGoogleAnalytics } from "shared-components/GlobalHooks/web/GoogleAnalytics.hook";
import { useRouter } from "next/router";

const categoryName = "app-promo";
const APP_PROMO_LOCALSTORAGE_KEY = "app_promo_displayed";

dayjs.locale("es");


export const BannerAppPromotion = () => {
	const [show, setShow] = useState<boolean>(true)
	const router = useRouter()	
	const START_TIME = dayjs("9/09/2021 10:45", "D/M/YYYY HH:m");
	const END_TIME = dayjs("9/09/2021 12:15", "D/M/YYYY HH:m");
	const d = dayjs();

	const { pathname } = useRouter();
	const GA = useGoogleAnalytics();

	const [fade, setFade] = useState(false);
	const [bannerPositionClass, setBannerPositionClass] = useState("position-bottom");
	const { country_code } = useContext(ConfigStateContext);

	const href = country_code == "ce3" ? "https://onelink.to/x7r2zf" : "http://onelink.to/rhh4cu"
	
	const runAction = action => {
		setFade(true);
		GA.Event({ category: categoryName, action });

		if (action === "open") {
			localStorage.setItem(APP_PROMO_LOCALSTORAGE_KEY, "true")
		} else {
			const now = dayjs().format();
			setTimeout(() => localStorage.setItem(APP_PROMO_LOCALSTORAGE_KEY, now), 500);
		}
	};

	const closeButtonHandler = (e) => {
		e.stopPropagation()
		e.preventDefault()
		runAction("close")
	}


	useEffect(() => {
		if (router.asPath == '/move-to-the-app/favoritos' || router.asPath == '/move-to-the-app/mis-consultas') setShow(false)
	}, [])
	useEffect(() => {
		if (
			pathname === "/projectEspecialSingle" ||
			pathname === "/projectSingle" ||
			pathname === "/propSingle"
		)
			setBannerPositionClass("position-top");
	}, []);

	useEffect(() => {
		const lastDate = dayjs(localStorage.getItem(APP_PROMO_LOCALSTORAGE_KEY));
		if (lastDate) {
			const now = dayjs();
			const res = now.diff(lastDate, "day");
			if (res >= 2) localStorage.removeItem(APP_PROMO_LOCALSTORAGE_KEY);
		}

		if (
			localStorage.getItem(APP_PROMO_LOCALSTORAGE_KEY) != null ||
			(d.isSameOrAfter(START_TIME, "m") && d.isSameOrBefore(END_TIME, "m"))
		) {
			GA.Event({
				category: categoryName,
				action: "show",
			});
		}
	}, []);

	if (
		localStorage.getItem(APP_PROMO_LOCALSTORAGE_KEY) != null ||
		(d.isSameOrAfter(START_TIME, "m") && d.isSameOrBefore(END_TIME, "m"))
	){ return null; }
		

	return <>
		{show && 
			<a className={`banner-app-promo ${fade ? 'fade-out' : 'fade-in' }  ${bannerPositionClass}`} href={href} onClick={()=>{runAction("open")}} >
				Abrir App Infocasas
				<button onClick={closeButtonHandler} >x</button>
			</a>
		}
	</>

};



